/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  BulkMarkAsReadUserNotifications400Response,
  ChangePassword200Response,
  ChangePassword422Response,
  ChangePasswordRequest,
  Exchange200Response,
  Exchange400Response,
  Exchange404Response,
  Exchange422Response,
  ExchangeRequest,
  Export400Response,
  FindOrCreateUser200Response,
  FindOrCreateUser403Response,
  FindOrCreateUserRequest,
  ForgetPassword200Response,
  ForgetPassword422Response,
  ForgetPasswordRequest,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetCommonState400Response,
  GetCommonState403Response,
  GetMeta200Response,
  GetNotificationEmails200Response,
  GetNotificationEmails400Response,
  GetPartnerSettings403Response,
  GetUserDocumentItem404Response,
  GetUserNotifications200Response,
  GetUserNotifications400Response,
  GetUserNotifications422Response,
  GetUserProfile200Response,
  Login200Response,
  Login400Response,
  Login401Response,
  LoginRequest,
  Logout200Response,
  MarkInstructionPassed400Response,
  NewPassword422Response,
  NewPasswordRequest,
  OauthAuthorizeApprove400Response,
  OauthLogin200Response,
  OauthLogin400Response,
  OauthLogin401Response,
  OauthLoginRequest,
  OauthTokenRefreshRequest,
  Registration200Response,
  Registration400Response,
  Registration422Response,
  Registration429Response,
  RegistrationRequest,
  ResendVerificationEmail200Response,
  ResendVerificationEmail400Response,
  ResendVerificationEmail422Response,
  ResendVerificationEmailRequest,
  ResetPasswordToken200Response,
  ResetPasswordToken400Response,
  ResetPasswordToken404Response,
  ResetPasswordToken422Response,
  ResetPasswordTokenRequest,
  SaveAffiliateProgram200Response,
  SaveAffiliateProgram422Response,
  SaveAffiliateProgramRequest,
  SaveNotificationEmail400Response,
  SaveNotificationEmail422Response,
  SaveNotificationEmailRequest,
  SearchInstructions422Response,
  UpdateUserProfile422Response,
  UpdateUserProfileRequest,
  VerifyEmail200Response,
  VerifyEmail400Response,
  VerifyEmail500Response,
} from '../models/index'
import {
  BulkMarkAsReadUserNotifications400ResponseFromJSON,
  BulkMarkAsReadUserNotifications400ResponseToJSON,
  ChangePassword200ResponseFromJSON,
  ChangePassword200ResponseToJSON,
  ChangePassword422ResponseFromJSON,
  ChangePassword422ResponseToJSON,
  ChangePasswordRequestFromJSON,
  ChangePasswordRequestToJSON,
  Exchange200ResponseFromJSON,
  Exchange200ResponseToJSON,
  Exchange400ResponseFromJSON,
  Exchange400ResponseToJSON,
  Exchange404ResponseFromJSON,
  Exchange404ResponseToJSON,
  Exchange422ResponseFromJSON,
  Exchange422ResponseToJSON,
  ExchangeRequestFromJSON,
  ExchangeRequestToJSON,
  Export400ResponseFromJSON,
  Export400ResponseToJSON,
  FindOrCreateUser200ResponseFromJSON,
  FindOrCreateUser200ResponseToJSON,
  FindOrCreateUser403ResponseFromJSON,
  FindOrCreateUser403ResponseToJSON,
  FindOrCreateUserRequestFromJSON,
  FindOrCreateUserRequestToJSON,
  ForgetPassword200ResponseFromJSON,
  ForgetPassword200ResponseToJSON,
  ForgetPassword422ResponseFromJSON,
  ForgetPassword422ResponseToJSON,
  ForgetPasswordRequestFromJSON,
  ForgetPasswordRequestToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetCommonState403ResponseFromJSON,
  GetCommonState403ResponseToJSON,
  GetMeta200ResponseFromJSON,
  GetMeta200ResponseToJSON,
  GetNotificationEmails200ResponseFromJSON,
  GetNotificationEmails200ResponseToJSON,
  GetNotificationEmails400ResponseFromJSON,
  GetNotificationEmails400ResponseToJSON,
  GetPartnerSettings403ResponseFromJSON,
  GetPartnerSettings403ResponseToJSON,
  GetUserDocumentItem404ResponseFromJSON,
  GetUserDocumentItem404ResponseToJSON,
  GetUserNotifications200ResponseFromJSON,
  GetUserNotifications200ResponseToJSON,
  GetUserNotifications400ResponseFromJSON,
  GetUserNotifications400ResponseToJSON,
  GetUserNotifications422ResponseFromJSON,
  GetUserNotifications422ResponseToJSON,
  GetUserProfile200ResponseFromJSON,
  GetUserProfile200ResponseToJSON,
  Login200ResponseFromJSON,
  Login200ResponseToJSON,
  Login400ResponseFromJSON,
  Login400ResponseToJSON,
  Login401ResponseFromJSON,
  Login401ResponseToJSON,
  LoginRequestFromJSON,
  LoginRequestToJSON,
  Logout200ResponseFromJSON,
  Logout200ResponseToJSON,
  MarkInstructionPassed400ResponseFromJSON,
  MarkInstructionPassed400ResponseToJSON,
  NewPassword422ResponseFromJSON,
  NewPassword422ResponseToJSON,
  NewPasswordRequestFromJSON,
  NewPasswordRequestToJSON,
  OauthAuthorizeApprove400ResponseFromJSON,
  OauthAuthorizeApprove400ResponseToJSON,
  OauthLogin200ResponseFromJSON,
  OauthLogin200ResponseToJSON,
  OauthLogin400ResponseFromJSON,
  OauthLogin400ResponseToJSON,
  OauthLogin401ResponseFromJSON,
  OauthLogin401ResponseToJSON,
  OauthLoginRequestFromJSON,
  OauthLoginRequestToJSON,
  OauthTokenRefreshRequestFromJSON,
  OauthTokenRefreshRequestToJSON,
  Registration200ResponseFromJSON,
  Registration200ResponseToJSON,
  Registration400ResponseFromJSON,
  Registration400ResponseToJSON,
  Registration422ResponseFromJSON,
  Registration422ResponseToJSON,
  Registration429ResponseFromJSON,
  Registration429ResponseToJSON,
  RegistrationRequestFromJSON,
  RegistrationRequestToJSON,
  ResendVerificationEmail200ResponseFromJSON,
  ResendVerificationEmail200ResponseToJSON,
  ResendVerificationEmail400ResponseFromJSON,
  ResendVerificationEmail400ResponseToJSON,
  ResendVerificationEmail422ResponseFromJSON,
  ResendVerificationEmail422ResponseToJSON,
  ResendVerificationEmailRequestFromJSON,
  ResendVerificationEmailRequestToJSON,
  ResetPasswordToken200ResponseFromJSON,
  ResetPasswordToken200ResponseToJSON,
  ResetPasswordToken400ResponseFromJSON,
  ResetPasswordToken400ResponseToJSON,
  ResetPasswordToken404ResponseFromJSON,
  ResetPasswordToken404ResponseToJSON,
  ResetPasswordToken422ResponseFromJSON,
  ResetPasswordToken422ResponseToJSON,
  ResetPasswordTokenRequestFromJSON,
  ResetPasswordTokenRequestToJSON,
  SaveAffiliateProgram200ResponseFromJSON,
  SaveAffiliateProgram200ResponseToJSON,
  SaveAffiliateProgram422ResponseFromJSON,
  SaveAffiliateProgram422ResponseToJSON,
  SaveAffiliateProgramRequestFromJSON,
  SaveAffiliateProgramRequestToJSON,
  SaveNotificationEmail400ResponseFromJSON,
  SaveNotificationEmail400ResponseToJSON,
  SaveNotificationEmail422ResponseFromJSON,
  SaveNotificationEmail422ResponseToJSON,
  SaveNotificationEmailRequestFromJSON,
  SaveNotificationEmailRequestToJSON,
  SearchInstructions422ResponseFromJSON,
  SearchInstructions422ResponseToJSON,
  UpdateUserProfile422ResponseFromJSON,
  UpdateUserProfile422ResponseToJSON,
  UpdateUserProfileRequestFromJSON,
  UpdateUserProfileRequestToJSON,
  VerifyEmail200ResponseFromJSON,
  VerifyEmail200ResponseToJSON,
  VerifyEmail400ResponseFromJSON,
  VerifyEmail400ResponseToJSON,
  VerifyEmail500ResponseFromJSON,
  VerifyEmail500ResponseToJSON,
} from '../models/index'

export interface ChangePasswordOperationRequest {
  changePasswordRequest: ChangePasswordRequest
}

export interface ExchangeOperationRequest {
  exchangeRequest: ExchangeRequest
}

export interface FindOrCreateUserOperationRequest {
  findOrCreateUserRequest: FindOrCreateUserRequest
}

export interface ForgetPasswordOperationRequest {
  forgetPasswordRequest: ForgetPasswordRequest
}

export interface GetUserNotificationsRequest {
  notificationType?: GetUserNotificationsNotificationTypeEnum
  page?: number
  perPage?: number
}

export interface LoginOperationRequest {
  loginRequest: LoginRequest
}

export interface NewPasswordOperationRequest {
  newPasswordRequest: NewPasswordRequest
}

export interface OauthAuthorizeRequest {
  responseType: OauthAuthorizeResponseTypeEnum
  clientId: string
  redirectUri?: string
  scope?: string
  state?: string
  prompt?: OauthAuthorizePromptEnum
}

export interface OauthAuthorizeApproveRequest {
  authToken: string
  token?: string
}

export interface OauthAuthorizeDenyRequest {
  authToken: string
  token?: string
}

export interface OauthLoginOperationRequest {
  oauthLoginRequest: OauthLoginRequest
}

export interface OauthLoginFormRequest {
  clientId?: string
  state?: string
  redirectUri?: string
}

export interface OauthLoginSubmitRequest {
  email: string
  password: string
  token?: string
}

export interface OauthTokenRefreshOperationRequest {
  oauthTokenRefreshRequest: OauthTokenRefreshRequest
}

export interface ReadUserNotificationRequest {
  notification: string
}

export interface RegistrationOperationRequest {
  registrationRequest: RegistrationRequest
}

export interface ResendVerificationEmailOperationRequest {
  resendVerificationEmailRequest: ResendVerificationEmailRequest
}

export interface ResetPasswordTokenOperationRequest {
  resetPasswordTokenRequest: ResetPasswordTokenRequest
}

export interface SaveAffiliateProgramOperationRequest {
  saveAffiliateProgramRequest: SaveAffiliateProgramRequest
}

export interface SaveNotificationEmailOperationRequest {
  saveNotificationEmailRequest: SaveNotificationEmailRequest
}

export interface TokenRefreshRequest {
  oauthTokenRefreshRequest: OauthTokenRefreshRequest
}

export interface UpdateUserProfileOperationRequest {
  updateUserProfileRequest: UpdateUserProfileRequest
}

export interface VerifyEmailRequest {
  id: string
  hash: string
}

/**
 * UserApi - interface
 *
 * @export
 * @interface UserApiInterface
 */
export interface UserApiInterface {
  /**
   * Принятие пользователем оферты: фиксирует время принятия и возвращает обновлённые данные пользователя.
   * @summary Принять оферту
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  acceptAgreementRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Registration200Response>>

  /**
   * Принятие пользователем оферты: фиксирует время принятия и возвращает обновлённые данные пользователя.
   * Принять оферту
   */
  acceptAgreement(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Registration200Response>

  /**
   * Отмечает все непрочитанные уведомления текущего пользователя прочитанными одним запросом.
   * @summary Отметить все уведомления прочитанными
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  bulkMarkAsReadUserNotificationsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>>

  /**
   * Отмечает все непрочитанные уведомления текущего пользователя прочитанными одним запросом.
   * Отметить все уведомления прочитанными
   */
  bulkMarkAsReadUserNotifications(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response>

  /**
   * Смена пароля текущего аутентифицированного пользователя: текущий пароль проверяется хэшем, новый должен отличаться от текущего. Минимальная длина пароля задаётся серверной настройкой. Требуется подтверждённый email.
   * @summary Изменить пароль пользователя
   * @param {ChangePasswordRequest} changePasswordRequest Текущий и новый пароль с подтверждением
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  changePasswordRaw(
    requestParameters: ChangePasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ChangePassword200Response>>

  /**
   * Смена пароля текущего аутентифицированного пользователя: текущий пароль проверяется хэшем, новый должен отличаться от текущего. Минимальная длина пароля задаётся серверной настройкой. Требуется подтверждённый email.
   * Изменить пароль пользователя
   */
  changePassword(
    requestParameters: ChangePasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ChangePassword200Response>

  /**
   * Обмен одноразового авторизационного кода на токены (iframe-авторизация партнёров). При выпуске кода клиентом с авторегистрацией пользователь без подтверждённого email верифицируется автоматически.
   * @summary Авторизация для партнёров через iframe
   * @param {ExchangeRequest} exchangeRequest Одноразовый авторизационный код
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  exchangeRaw(
    requestParameters: ExchangeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Exchange200Response>>

  /**
   * Обмен одноразового авторизационного кода на токены (iframe-авторизация партнёров). При выпуске кода клиентом с авторегистрацией пользователь без подтверждённого email верифицируется автоматически.
   * Авторизация для партнёров через iframe
   */
  exchange(
    requestParameters: ExchangeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Exchange200Response>

  /**
   * Поиск пользователя по email/телефону от имени OAuth-клиента внешней интеграции; при отсутствии — создание пользователя и внешнего контакта (+ контакт/сделка AmoCRM). Возвращает одноразовый авторизационный код для обмена через /oaclients/exchange. Поведение зависит от ролей клиента (автоверификация, авторегистрация, «не беспокоить»). Требуется подтверждённый email.
   * @summary Найти или создать пользователя интеграции
   * @param {FindOrCreateUserRequest} findOrCreateUserRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  findOrCreateUserRaw(
    requestParameters: FindOrCreateUserOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FindOrCreateUser200Response>>

  /**
   * Поиск пользователя по email/телефону от имени OAuth-клиента внешней интеграции; при отсутствии — создание пользователя и внешнего контакта (+ контакт/сделка AmoCRM). Возвращает одноразовый авторизационный код для обмена через /oaclients/exchange. Поведение зависит от ролей клиента (автоверификация, авторегистрация, «не беспокоить»). Требуется подтверждённый email.
   * Найти или создать пользователя интеграции
   */
  findOrCreateUser(
    requestParameters: FindOrCreateUserOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FindOrCreateUser200Response>

  /**
   * Запрос сброса пароля: на почту пользователя отправляется 6-значный код подтверждения (действует 30 минут, предыдущий код аннулируется). Публичный эндпоинт. Существование аккаунта не раскрывается: и отсутствие пользователя, и внутренняя ошибка возвращают один и тот же ответ UNDEFINED_ERROR.
   * @summary Запрос кода сброса пароля
   * @param {ForgetPasswordRequest} forgetPasswordRequest Email пользователя
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  forgetPasswordRaw(
    requestParameters: ForgetPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ForgetPassword200Response>>

  /**
   * Запрос сброса пароля: на почту пользователя отправляется 6-значный код подтверждения (действует 30 минут, предыдущий код аннулируется). Публичный эндпоинт. Существование аккаунта не раскрывается: и отсутствие пользователя, и внутренняя ошибка возвращают один и тот же ответ UNDEFINED_ERROR.
   * Запрос кода сброса пароля
   */
  forgetPassword(
    requestParameters: ForgetPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ForgetPassword200Response>

  /**
   * Возвращает данные пользователя, аутентифицированного Bearer-токеном. Требуется подтверждённый email.
   * @summary Текущий пользователь
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  getContactDataRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Registration200Response>>

  /**
   * Возвращает данные пользователя, аутентифицированного Bearer-токеном. Требуется подтверждённый email.
   * Текущий пользователь
   */
  getContactData(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Registration200Response>

  /**
   * Мета-данные организации текущего пользователя (тип и данные организации из users_meta). Если запись мета-данных отсутствует — data: null. Требуется подтверждённый email.
   * @summary Мета-данные пользователя
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  getMetaRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetMeta200Response>>

  /**
   * Мета-данные организации текущего пользователя (тип и данные организации из users_meta). Если запись мета-данных отсутствует — data: null. Требуется подтверждённый email.
   * Мета-данные пользователя
   */
  getMeta(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetMeta200Response>

  /**
   * Список email-адресов, на которые пользователь желает получать уведомления. Требуется подтверждённый email.
   * @summary Список почт для уведомлений
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  getNotificationEmailsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNotificationEmails200Response>>

  /**
   * Список email-адресов, на которые пользователь желает получать уведомления. Требуется подтверждённый email.
   * Список почт для уведомлений
   */
  getNotificationEmails(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNotificationEmails200Response>

  /**
   * Постраничный список уведомлений текущего пользователя. Сортировка: по дате создания по убыванию (новые выше), независимо от признака прочтения. Если notificationType не передан, возвращаются все уведомления. Рядом с data возвращаются pagination (мета пагинации) и meta (счётчики уведомлений по признаку прочтения: all — всего, unread — непрочитанных, read — прочитанных; без учёта фильтра notificationType). Требуется подтверждённый email.
   * @summary Список уведомлений пользователя
   * @param {'all' | 'unread' | 'read'} [notificationType] Фильтр по признаку прочтения (по умолчанию — все)
   * @param {number} [page] Номер страницы (по умолчанию 1)
   * @param {number} [perPage] Записей на странице, 1–150 (по умолчанию 12)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  getUserNotificationsRaw(
    requestParameters: GetUserNotificationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserNotifications200Response>>

  /**
   * Постраничный список уведомлений текущего пользователя. Сортировка: по дате создания по убыванию (новые выше), независимо от признака прочтения. Если notificationType не передан, возвращаются все уведомления. Рядом с data возвращаются pagination (мета пагинации) и meta (счётчики уведомлений по признаку прочтения: all — всего, unread — непрочитанных, read — прочитанных; без учёта фильтра notificationType). Требуется подтверждённый email.
   * Список уведомлений пользователя
   */
  getUserNotifications(
    requestParameters: GetUserNotificationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserNotifications200Response>

  /**
   * Личные данные текущего пользователя, аутентифицированного Bearer-токеном (ФИО, email, телефон). Требуется подтверждённый email.
   * @summary Получить информацию о пользователе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  getUserProfileRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserProfile200Response>>

  /**
   * Личные данные текущего пользователя, аутентифицированного Bearer-токеном (ФИО, email, телефон). Требуется подтверждённый email.
   * Получить информацию о пользователе
   */
  getUserProfile(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserProfile200Response>

  /**
   * Выпуск access/refresh токенов (OAuth2 password или authorization_code grant) через адаптер над Passport. Дополнительно принимает промокод и UTM-метки (utmClientId, utm_source и др.) для трекинга. Для пользователя с неподтверждённым email при корректных кредах возвращается 403 EMAIL_NOT_VERIFIED; повторное письмо подтверждения отправляется автоматически с учётом кулдауна и лимита (5 писем за 4 часа) (см. POST /auth/email/resend для статуса попыток).
   * @summary Авторизация
   * @param {LoginRequest} loginRequest Параметры OAuth2 grant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  loginRaw(
    requestParameters: LoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Login200Response>>

  /**
   * Выпуск access/refresh токенов (OAuth2 password или authorization_code grant) через адаптер над Passport. Дополнительно принимает промокод и UTM-метки (utmClientId, utm_source и др.) для трекинга. Для пользователя с неподтверждённым email при корректных кредах возвращается 403 EMAIL_NOT_VERIFIED; повторное письмо подтверждения отправляется автоматически с учётом кулдауна и лимита (5 писем за 4 часа) (см. POST /auth/email/resend для статуса попыток).
   * Авторизация
   */
  login(
    requestParameters: LoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Login200Response>

  /**
   * Выход: отзыв access-токена и всех привязанных к нему refresh-токенов текущей сессии.
   * @summary Выход
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  logoutRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>>

  /**
   * Выход: отзыв access-токена и всех привязанных к нему refresh-токенов текущей сессии.
   * Выход
   */
  logout(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response>

  /**
   * Отметка текущим пользователем прохождения инструкции (instruction_passed = true). Требуется подтверждённый email.
   * @summary Отметить инструкцию пройденной
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  markInstructionPassedRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>>

  /**
   * Отметка текущим пользователем прохождения инструкции (instruction_passed = true). Требуется подтверждённый email.
   * Отметить инструкцию пройденной
   */
  markInstructionPassed(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response>

  /**
   * Установка нового пароля по верификационному токену из ответа /api/v1/user/reset-password-token. Токен одноразовый, действует 10 минут. После смены пароля пользователю отправляется уведомление. Публичный эндпоинт. Особенность: при неверном или просроченном верификационном токене HTTP-код остаётся 200, ошибка передаётся в теле ответа ({status: false, message}).
   * @summary Установка нового пароля
   * @param {NewPasswordRequest} newPasswordRequest Верификационный токен и новый пароль
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  newPasswordRaw(
    requestParameters: NewPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>>

  /**
   * Установка нового пароля по верификационному токену из ответа /api/v1/user/reset-password-token. Токен одноразовый, действует 10 минут. После смены пароля пользователю отправляется уведомление. Публичный эндпоинт. Особенность: при неверном или просроченном верификационном токене HTTP-код остаётся 200, ошибка передаётся в теле ответа ({status: false, message}).
   * Установка нового пароля
   */
  newPassword(
    requestParameters: NewPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response>

  /**
   * Шаг подтверждения authorization code flow: валидация OAuth-запроса и показ страницы согласия. Браузерный эндпоинт (middleware web, сессия). Неаутентифицированного пользователя редиректит на /oauth/login с сохранением исходных параметров.
   * @summary Подтверждение доступа OAuth-клиента
   * @param {'code'} responseType Тип ответа authorization code flow
   * @param {string} clientId ID OAuth-клиента
   * @param {string} [redirectUri] URI редиректа клиента (обязателен, если зарегистрировано несколько)
   * @param {string} [scope] Запрашиваемые скоупы через пробел
   * @param {string} [state] Произвольное состояние клиента (возвращается в redirect_uri)
   * @param {'none' | 'login' | 'consent'} [prompt] Режим: none — без показа UI (иначе отказ), login — принудительный повторный вход, consent — принудительный показ согласия
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  oauthAuthorizeRaw(
    requestParameters: OauthAuthorizeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>>

  /**
   * Шаг подтверждения authorization code flow: валидация OAuth-запроса и показ страницы согласия. Браузерный эндпоинт (middleware web, сессия). Неаутентифицированного пользователя редиректит на /oauth/login с сохранением исходных параметров.
   * Подтверждение доступа OAuth-клиента
   */
  oauthAuthorize(
    requestParameters: OauthAuthorizeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string>

  /**
   * Отправка формы согласия со страницы /oauth/authorize: выпуск authorization code и редирект на redirect_uri клиента. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * @summary Одобрить запрос авторизации
   * @param {string} authToken Токен подтверждения со страницы согласия (сессионный authToken)
   * @param {string} [token] CSRF-токен (middleware web)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  oauthAuthorizeApproveRaw(
    requestParameters: OauthAuthorizeApproveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Отправка формы согласия со страницы /oauth/authorize: выпуск authorization code и редирект на redirect_uri клиента. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * Одобрить запрос авторизации
   */
  oauthAuthorizeApprove(
    requestParameters: OauthAuthorizeApproveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void>

  /**
   * Отказ в согласии со страницы /oauth/authorize: редирект на redirect_uri клиента с error=access_denied и state. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * @summary Отклонить запрос авторизации
   * @param {string} authToken Токен подтверждения со страницы согласия (сессионный authToken)
   * @param {string} [token] CSRF-токен (middleware web)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  oauthAuthorizeDenyRaw(
    requestParameters: OauthAuthorizeDenyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Отказ в согласии со страницы /oauth/authorize: редирект на redirect_uri клиента с error=access_denied и state. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * Отклонить запрос авторизации
   */
  oauthAuthorizeDeny(
    requestParameters: OauthAuthorizeDenyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void>

  /**
   * Выпуск access/refresh токенов напрямую через OAuth2-сервер Passport (grants: password, authorization_code). В отличие от /api/v1/login возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * @summary Авторизация (OAuth2 token)
   * @param {OauthLoginRequest} oauthLoginRequest Параметры OAuth2 grant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  oauthLoginRaw(
    requestParameters: OauthLoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OauthLogin200Response>>

  /**
   * Выпуск access/refresh токенов напрямую через OAuth2-сервер Passport (grants: password, authorization_code). В отличие от /api/v1/login возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * Авторизация (OAuth2 token)
   */
  oauthLogin(
    requestParameters: OauthLoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OauthLogin200Response>

  /**
   * Отдельная страница входа для OAuth authorization code flow: при наличии client_id/state сохраняет все параметры запроса в сессию для возврата на /oauth/authorize после входа. Браузерный эндпоинт (middleware web, сессия).
   * @summary Страница входа OAuth
   * @param {string} [clientId] ID OAuth-клиента (сохраняется в сессию)
   * @param {string} [state] Состояние клиента (сохраняется в сессию)
   * @param {string} [redirectUri] URI редиректа клиента (сохраняется в сессию)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  oauthLoginFormRaw(
    requestParameters: OauthLoginFormRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>>

  /**
   * Отдельная страница входа для OAuth authorization code flow: при наличии client_id/state сохраняет все параметры запроса в сессию для возврата на /oauth/authorize после входа. Браузерный эндпоинт (middleware web, сессия).
   * Страница входа OAuth
   */
  oauthLoginForm(
    requestParameters: OauthLoginFormRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string>

  /**
   * Вход по email/паролю (guard web, сессия + CSRF) со страницы OAuth. При успехе — редирект на /oauth/authorize с сохранёнными в сессии параметрами (или на /, если их не было), при неудаче — назад на форму с ошибками в сессии.
   * @summary Вход на странице OAuth
   * @param {string} email Электронная почта
   * @param {string} password Пароль
   * @param {string} [token] CSRF-токен (middleware web)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  oauthLoginSubmitRaw(
    requestParameters: OauthLoginSubmitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Вход по email/паролю (guard web, сессия + CSRF) со страницы OAuth. При успехе — редирект на /oauth/authorize с сохранёнными в сессии параметрами (или на /, если их не было), при неудаче — назад на форму с ошибками в сессии.
   * Вход на странице OAuth
   */
  oauthLoginSubmit(
    requestParameters: OauthLoginSubmitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void>

  /**
   * Обновление пары токенов напрямую через OAuth2-сервер Passport (grant refresh_token). Возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * @summary Обновление аутентификации (OAuth2 refresh)
   * @param {OauthTokenRefreshRequest} oauthTokenRefreshRequest Параметры OAuth2 refresh grant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  oauthTokenRefreshRaw(
    requestParameters: OauthTokenRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OauthLogin200Response>>

  /**
   * Обновление пары токенов напрямую через OAuth2-сервер Passport (grant refresh_token). Возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * Обновление аутентификации (OAuth2 refresh)
   */
  oauthTokenRefresh(
    requestParameters: OauthTokenRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OauthLogin200Response>

  /**
   * Отмечает уведомление прочитанным. Отметить можно только собственное уведомление текущего пользователя.
   * @summary Отметить уведомление прочитанным
   * @param {string} notification UUID уведомления
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  readUserNotificationRaw(
    requestParameters: ReadUserNotificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>>

  /**
   * Отмечает уведомление прочитанным. Отметить можно только собственное уведомление текущего пользователя.
   * Отметить уведомление прочитанным
   */
  readUserNotification(
    requestParameters: ReadUserNotificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response>

  /**
   * Регистрация нового пользователя. Throttle 5 запросов/мин с IP; UTM-метки и промокод (utmClientId, promocode) фиксируются middleware для трекинга. Пользователь создаётся с неподтверждённым email — письмо подтверждения отправляется на указанный адрес.
   * @summary Зарегистрировать нового пользователя
   * @param {RegistrationRequest} registrationRequest Данные регистрации
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  registrationRaw(
    requestParameters: RegistrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Registration200Response>>

  /**
   * Регистрация нового пользователя. Throttle 5 запросов/мин с IP; UTM-метки и промокод (utmClientId, promocode) фиксируются middleware для трекинга. Пользователь создаётся с неподтверждённым email — письмо подтверждения отправляется на указанный адрес.
   * Зарегистрировать нового пользователя
   */
  registration(
    requestParameters: RegistrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Registration200Response>

  /**
   * Повторная отправка письма подтверждения email по адресу (без авторизации). Троттлинг выполняется в контроллере: лимит 5 писем на адрес за окно 4 часа, минимальная пауза между письмами 60 секунд (счётчики в Redis) и per-IP лимит запросов в минуту. Ответ для несуществующего email имитирует нулевые счётчики (anti-enumeration), письмо не отправляется.
   * @summary Повторная отправка письма подтверждения
   * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest Email зарегистрированного пользователя
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  resendVerificationEmailRaw(
    requestParameters: ResendVerificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResendVerificationEmail200Response>>

  /**
   * Повторная отправка письма подтверждения email по адресу (без авторизации). Троттлинг выполняется в контроллере: лимит 5 писем на адрес за окно 4 часа, минимальная пауза между письмами 60 секунд (счётчики в Redis) и per-IP лимит запросов в минуту. Ответ для несуществующего email имитирует нулевые счётчики (anti-enumeration), письмо не отправляется.
   * Повторная отправка письма подтверждения
   */
  resendVerificationEmail(
    requestParameters: ResendVerificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResendVerificationEmail200Response>

  /**
   * Подтверждение кода сброса, пришедшего на почту (запрашивается через /api/v1/user/forget-password). Код одноразовый: после проверки выпускается верификационный токен (действует 10 минут) для установки нового пароля через /api/v1/user/new-password. Публичный эндпоинт.
   * @summary Проверка кода сброса пароля
   * @param {ResetPasswordTokenRequest} resetPasswordTokenRequest Код сброса из письма
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  resetPasswordTokenRaw(
    requestParameters: ResetPasswordTokenOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResetPasswordToken200Response>>

  /**
   * Подтверждение кода сброса, пришедшего на почту (запрашивается через /api/v1/user/forget-password). Код одноразовый: после проверки выпускается верификационный токен (действует 10 минут) для установки нового пароля через /api/v1/user/new-password. Публичный эндпоинт.
   * Проверка кода сброса пароля
   */
  resetPasswordToken(
    requestParameters: ResetPasswordTokenOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResetPasswordToken200Response>

  /**
   * Заявка в партнёрскую программу: сохраняет email для партнёрской программы текущего пользователя. Идемпотентно — повторный запрос с уже сохранённым email не создаёт дубликат. Требуется подтверждённый email.
   * @summary Заявка в партнёрскую программу
   * @param {SaveAffiliateProgramRequest} saveAffiliateProgramRequest Email для партнёрской программы
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  saveAffiliateProgramRaw(
    requestParameters: SaveAffiliateProgramOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SaveAffiliateProgram200Response>>

  /**
   * Заявка в партнёрскую программу: сохраняет email для партнёрской программы текущего пользователя. Идемпотентно — повторный запрос с уже сохранённым email не создаёт дубликат. Требуется подтверждённый email.
   * Заявка в партнёрскую программу
   */
  saveAffiliateProgram(
    requestParameters: SaveAffiliateProgramOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SaveAffiliateProgram200Response>

  /**
   * Полная замена списка почт для уведомлений: переданный массив синхронизируется со списком пользователя (отсутствующие в запросе записи удаляются). Максимум 7 адресов, все должны быть уникальны. Требуется подтверждённый email.
   * @summary Сохранить список почт для уведомлений
   * @param {SaveNotificationEmailRequest} saveNotificationEmailRequest Массив email-адресов (до 7 уникальных); null или пустой массив очищает список
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  saveNotificationEmailRaw(
    requestParameters: SaveNotificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNotificationEmails200Response>>

  /**
   * Полная замена списка почт для уведомлений: переданный массив синхронизируется со списком пользователя (отсутствующие в запросе записи удаляются). Максимум 7 адресов, все должны быть уникальны. Требуется подтверждённый email.
   * Сохранить список почт для уведомлений
   */
  saveNotificationEmail(
    requestParameters: SaveNotificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNotificationEmails200Response>

  /**
   * Обновление пары токенов по refresh_token (OAuth2 refresh grant) через адаптер над Passport.
   * @summary Обновление аутентификации
   * @param {OauthTokenRefreshRequest} oauthTokenRefreshRequest Параметры OAuth2 refresh grant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  tokenRefreshRaw(
    requestParameters: TokenRefreshRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Login200Response>>

  /**
   * Обновление пары токенов по refresh_token (OAuth2 refresh grant) через адаптер над Passport.
   * Обновление аутентификации
   */
  tokenRefresh(
    requestParameters: TokenRefreshRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Login200Response>

  /**
   * Обновление личных данных текущего пользователя: ФИО и телефон (таблица users), тип и данные организации (таблица users_meta). Телефон уникален среди пользователей. Требуется подтверждённый email.
   * @summary Обновить данные пользователя
   * @param {UpdateUserProfileRequest} updateUserProfileRequest Новые личные данные пользователя
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  updateUserProfileRaw(
    requestParameters: UpdateUserProfileOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserProfile200Response>>

  /**
   * Обновление личных данных текущего пользователя: ФИО и телефон (таблица users), тип и данные организации (таблица users_meta). Телефон уникален среди пользователей. Требуется подтверждённый email.
   * Обновить данные пользователя
   */
  updateUserProfile(
    requestParameters: UpdateUserProfileOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserProfile200Response>

  /**
   * Подтверждение email по подписанной ссылке (relative signed URL) из письма. При успехе сразу выпускается пара токенов для входа в личный кабинет. Throttle 10 запросов/мин с IP.
   * @summary Подтверждение email
   * @param {string} id UUID пользователя
   * @param {string} hash SHA1-хеш email пользователя
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiInterface
   */
  verifyEmailRaw(
    requestParameters: VerifyEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<VerifyEmail200Response>>

  /**
   * Подтверждение email по подписанной ссылке (relative signed URL) из письма. При успехе сразу выпускается пара токенов для входа в личный кабинет. Throttle 10 запросов/мин с IP.
   * Подтверждение email
   */
  verifyEmail(
    requestParameters: VerifyEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<VerifyEmail200Response>
}

/**
 *
 */
export class UserApi extends runtime.BaseAPI implements UserApiInterface {
  /**
   * Принятие пользователем оферты: фиксирует время принятия и возвращает обновлённые данные пользователя.
   * Принять оферту
   */
  async acceptAgreementRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Registration200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/auth/accept-agreement`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Registration200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Принятие пользователем оферты: фиксирует время принятия и возвращает обновлённые данные пользователя.
   * Принять оферту
   */
  async acceptAgreement(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Registration200Response> {
    const response = await this.acceptAgreementRaw(initOverrides)
    return await response.value()
  }

  /**
   * Отмечает все непрочитанные уведомления текущего пользователя прочитанными одним запросом.
   * Отметить все уведомления прочитанными
   */
  async bulkMarkAsReadUserNotificationsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/notifications/bulk-mark-as-read`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Logout200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Отмечает все непрочитанные уведомления текущего пользователя прочитанными одним запросом.
   * Отметить все уведомления прочитанными
   */
  async bulkMarkAsReadUserNotifications(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response> {
    const response = await this.bulkMarkAsReadUserNotificationsRaw(
      initOverrides
    )
    return await response.value()
  }

  /**
   * Смена пароля текущего аутентифицированного пользователя: текущий пароль проверяется хэшем, новый должен отличаться от текущего. Минимальная длина пароля задаётся серверной настройкой. Требуется подтверждённый email.
   * Изменить пароль пользователя
   */
  async changePasswordRaw(
    requestParameters: ChangePasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ChangePassword200Response>> {
    if (requestParameters['changePasswordRequest'] == null) {
      throw new runtime.RequiredError(
        'changePasswordRequest',
        'Required parameter "changePasswordRequest" was null or undefined when calling changePassword().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/change-password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ChangePasswordRequestToJSON(
          requestParameters['changePasswordRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ChangePassword200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Смена пароля текущего аутентифицированного пользователя: текущий пароль проверяется хэшем, новый должен отличаться от текущего. Минимальная длина пароля задаётся серверной настройкой. Требуется подтверждённый email.
   * Изменить пароль пользователя
   */
  async changePassword(
    requestParameters: ChangePasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ChangePassword200Response> {
    const response = await this.changePasswordRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Обмен одноразового авторизационного кода на токены (iframe-авторизация партнёров). При выпуске кода клиентом с авторегистрацией пользователь без подтверждённого email верифицируется автоматически.
   * Авторизация для партнёров через iframe
   */
  async exchangeRaw(
    requestParameters: ExchangeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Exchange200Response>> {
    if (requestParameters['exchangeRequest'] == null) {
      throw new runtime.RequiredError(
        'exchangeRequest',
        'Required parameter "exchangeRequest" was null or undefined when calling exchange().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/oaclients/exchange`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ExchangeRequestToJSON(requestParameters['exchangeRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Exchange200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Обмен одноразового авторизационного кода на токены (iframe-авторизация партнёров). При выпуске кода клиентом с авторегистрацией пользователь без подтверждённого email верифицируется автоматически.
   * Авторизация для партнёров через iframe
   */
  async exchange(
    requestParameters: ExchangeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Exchange200Response> {
    const response = await this.exchangeRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Поиск пользователя по email/телефону от имени OAuth-клиента внешней интеграции; при отсутствии — создание пользователя и внешнего контакта (+ контакт/сделка AmoCRM). Возвращает одноразовый авторизационный код для обмена через /oaclients/exchange. Поведение зависит от ролей клиента (автоверификация, авторегистрация, «не беспокоить»). Требуется подтверждённый email.
   * Найти или создать пользователя интеграции
   */
  async findOrCreateUserRaw(
    requestParameters: FindOrCreateUserOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FindOrCreateUser200Response>> {
    if (requestParameters['findOrCreateUserRequest'] == null) {
      throw new runtime.RequiredError(
        'findOrCreateUserRequest',
        'Required parameter "findOrCreateUserRequest" was null or undefined when calling findOrCreateUser().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/oaclients/finduser`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: FindOrCreateUserRequestToJSON(
          requestParameters['findOrCreateUserRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FindOrCreateUser200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Поиск пользователя по email/телефону от имени OAuth-клиента внешней интеграции; при отсутствии — создание пользователя и внешнего контакта (+ контакт/сделка AmoCRM). Возвращает одноразовый авторизационный код для обмена через /oaclients/exchange. Поведение зависит от ролей клиента (автоверификация, авторегистрация, «не беспокоить»). Требуется подтверждённый email.
   * Найти или создать пользователя интеграции
   */
  async findOrCreateUser(
    requestParameters: FindOrCreateUserOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FindOrCreateUser200Response> {
    const response = await this.findOrCreateUserRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Запрос сброса пароля: на почту пользователя отправляется 6-значный код подтверждения (действует 30 минут, предыдущий код аннулируется). Публичный эндпоинт. Существование аккаунта не раскрывается: и отсутствие пользователя, и внутренняя ошибка возвращают один и тот же ответ UNDEFINED_ERROR.
   * Запрос кода сброса пароля
   */
  async forgetPasswordRaw(
    requestParameters: ForgetPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ForgetPassword200Response>> {
    if (requestParameters['forgetPasswordRequest'] == null) {
      throw new runtime.RequiredError(
        'forgetPasswordRequest',
        'Required parameter "forgetPasswordRequest" was null or undefined when calling forgetPassword().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/user/forget-password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ForgetPasswordRequestToJSON(
          requestParameters['forgetPasswordRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ForgetPassword200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Запрос сброса пароля: на почту пользователя отправляется 6-значный код подтверждения (действует 30 минут, предыдущий код аннулируется). Публичный эндпоинт. Существование аккаунта не раскрывается: и отсутствие пользователя, и внутренняя ошибка возвращают один и тот же ответ UNDEFINED_ERROR.
   * Запрос кода сброса пароля
   */
  async forgetPassword(
    requestParameters: ForgetPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ForgetPassword200Response> {
    const response = await this.forgetPasswordRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Возвращает данные пользователя, аутентифицированного Bearer-токеном. Требуется подтверждённый email.
   * Текущий пользователь
   */
  async getContactDataRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Registration200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/auth/me`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Registration200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Возвращает данные пользователя, аутентифицированного Bearer-токеном. Требуется подтверждённый email.
   * Текущий пользователь
   */
  async getContactData(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Registration200Response> {
    const response = await this.getContactDataRaw(initOverrides)
    return await response.value()
  }

  /**
   * Мета-данные организации текущего пользователя (тип и данные организации из users_meta). Если запись мета-данных отсутствует — data: null. Требуется подтверждённый email.
   * Мета-данные пользователя
   */
  async getMetaRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetMeta200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/meta`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetMeta200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Мета-данные организации текущего пользователя (тип и данные организации из users_meta). Если запись мета-данных отсутствует — data: null. Требуется подтверждённый email.
   * Мета-данные пользователя
   */
  async getMeta(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetMeta200Response> {
    const response = await this.getMetaRaw(initOverrides)
    return await response.value()
  }

  /**
   * Список email-адресов, на которые пользователь желает получать уведомления. Требуется подтверждённый email.
   * Список почт для уведомлений
   */
  async getNotificationEmailsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNotificationEmails200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/notification-emails`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetNotificationEmails200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список email-адресов, на которые пользователь желает получать уведомления. Требуется подтверждённый email.
   * Список почт для уведомлений
   */
  async getNotificationEmails(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNotificationEmails200Response> {
    const response = await this.getNotificationEmailsRaw(initOverrides)
    return await response.value()
  }

  /**
   * Постраничный список уведомлений текущего пользователя. Сортировка: по дате создания по убыванию (новые выше), независимо от признака прочтения. Если notificationType не передан, возвращаются все уведомления. Рядом с data возвращаются pagination (мета пагинации) и meta (счётчики уведомлений по признаку прочтения: all — всего, unread — непрочитанных, read — прочитанных; без учёта фильтра notificationType). Требуется подтверждённый email.
   * Список уведомлений пользователя
   */
  async getUserNotificationsRaw(
    requestParameters: GetUserNotificationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserNotifications200Response>> {
    const queryParameters: any = {}

    if (requestParameters['notificationType'] != null) {
      queryParameters['notificationType'] =
        requestParameters['notificationType']
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/notifications`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetUserNotifications200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Постраничный список уведомлений текущего пользователя. Сортировка: по дате создания по убыванию (новые выше), независимо от признака прочтения. Если notificationType не передан, возвращаются все уведомления. Рядом с data возвращаются pagination (мета пагинации) и meta (счётчики уведомлений по признаку прочтения: all — всего, unread — непрочитанных, read — прочитанных; без учёта фильтра notificationType). Требуется подтверждённый email.
   * Список уведомлений пользователя
   */
  async getUserNotifications(
    requestParameters: GetUserNotificationsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserNotifications200Response> {
    const response = await this.getUserNotificationsRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Личные данные текущего пользователя, аутентифицированного Bearer-токеном (ФИО, email, телефон). Требуется подтверждённый email.
   * Получить информацию о пользователе
   */
  async getUserProfileRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserProfile200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetUserProfile200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Личные данные текущего пользователя, аутентифицированного Bearer-токеном (ФИО, email, телефон). Требуется подтверждённый email.
   * Получить информацию о пользователе
   */
  async getUserProfile(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserProfile200Response> {
    const response = await this.getUserProfileRaw(initOverrides)
    return await response.value()
  }

  /**
   * Выпуск access/refresh токенов (OAuth2 password или authorization_code grant) через адаптер над Passport. Дополнительно принимает промокод и UTM-метки (utmClientId, utm_source и др.) для трекинга. Для пользователя с неподтверждённым email при корректных кредах возвращается 403 EMAIL_NOT_VERIFIED; повторное письмо подтверждения отправляется автоматически с учётом кулдауна и лимита (5 писем за 4 часа) (см. POST /auth/email/resend для статуса попыток).
   * Авторизация
   */
  async loginRaw(
    requestParameters: LoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Login200Response>> {
    if (requestParameters['loginRequest'] == null) {
      throw new runtime.RequiredError(
        'loginRequest',
        'Required parameter "loginRequest" was null or undefined when calling login().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/login`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LoginRequestToJSON(requestParameters['loginRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Login200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Выпуск access/refresh токенов (OAuth2 password или authorization_code grant) через адаптер над Passport. Дополнительно принимает промокод и UTM-метки (utmClientId, utm_source и др.) для трекинга. Для пользователя с неподтверждённым email при корректных кредах возвращается 403 EMAIL_NOT_VERIFIED; повторное письмо подтверждения отправляется автоматически с учётом кулдауна и лимита (5 писем за 4 часа) (см. POST /auth/email/resend для статуса попыток).
   * Авторизация
   */
  async login(
    requestParameters: LoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Login200Response> {
    const response = await this.loginRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Выход: отзыв access-токена и всех привязанных к нему refresh-токенов текущей сессии.
   * Выход
   */
  async logoutRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/auth/logout`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Logout200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Выход: отзыв access-токена и всех привязанных к нему refresh-токенов текущей сессии.
   * Выход
   */
  async logout(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response> {
    const response = await this.logoutRaw(initOverrides)
    return await response.value()
  }

  /**
   * Отметка текущим пользователем прохождения инструкции (instruction_passed = true). Требуется подтверждённый email.
   * Отметить инструкцию пройденной
   */
  async markInstructionPassedRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/instruction-passed`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Logout200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Отметка текущим пользователем прохождения инструкции (instruction_passed = true). Требуется подтверждённый email.
   * Отметить инструкцию пройденной
   */
  async markInstructionPassed(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response> {
    const response = await this.markInstructionPassedRaw(initOverrides)
    return await response.value()
  }

  /**
   * Установка нового пароля по верификационному токену из ответа /api/v1/user/reset-password-token. Токен одноразовый, действует 10 минут. После смены пароля пользователю отправляется уведомление. Публичный эндпоинт. Особенность: при неверном или просроченном верификационном токене HTTP-код остаётся 200, ошибка передаётся в теле ответа ({status: false, message}).
   * Установка нового пароля
   */
  async newPasswordRaw(
    requestParameters: NewPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>> {
    if (requestParameters['newPasswordRequest'] == null) {
      throw new runtime.RequiredError(
        'newPasswordRequest',
        'Required parameter "newPasswordRequest" was null or undefined when calling newPassword().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/user/new-password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NewPasswordRequestToJSON(requestParameters['newPasswordRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Logout200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Установка нового пароля по верификационному токену из ответа /api/v1/user/reset-password-token. Токен одноразовый, действует 10 минут. После смены пароля пользователю отправляется уведомление. Публичный эндпоинт. Особенность: при неверном или просроченном верификационном токене HTTP-код остаётся 200, ошибка передаётся в теле ответа ({status: false, message}).
   * Установка нового пароля
   */
  async newPassword(
    requestParameters: NewPasswordOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response> {
    const response = await this.newPasswordRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Шаг подтверждения authorization code flow: валидация OAuth-запроса и показ страницы согласия. Браузерный эндпоинт (middleware web, сессия). Неаутентифицированного пользователя редиректит на /oauth/login с сохранением исходных параметров.
   * Подтверждение доступа OAuth-клиента
   */
  async oauthAuthorizeRaw(
    requestParameters: OauthAuthorizeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['responseType'] == null) {
      throw new runtime.RequiredError(
        'responseType',
        'Required parameter "responseType" was null or undefined when calling oauthAuthorize().'
      )
    }

    if (requestParameters['clientId'] == null) {
      throw new runtime.RequiredError(
        'clientId',
        'Required parameter "clientId" was null or undefined when calling oauthAuthorize().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['responseType'] != null) {
      queryParameters['response_type'] = requestParameters['responseType']
    }

    if (requestParameters['clientId'] != null) {
      queryParameters['client_id'] = requestParameters['clientId']
    }

    if (requestParameters['redirectUri'] != null) {
      queryParameters['redirect_uri'] = requestParameters['redirectUri']
    }

    if (requestParameters['scope'] != null) {
      queryParameters['scope'] = requestParameters['scope']
    }

    if (requestParameters['state'] != null) {
      queryParameters['state'] = requestParameters['state']
    }

    if (requestParameters['prompt'] != null) {
      queryParameters['prompt'] = requestParameters['prompt']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/oauth/authorize`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response)
    } else {
      return new runtime.TextApiResponse(response) as any
    }
  }

  /**
   * Шаг подтверждения authorization code flow: валидация OAuth-запроса и показ страницы согласия. Браузерный эндпоинт (middleware web, сессия). Неаутентифицированного пользователя редиректит на /oauth/login с сохранением исходных параметров.
   * Подтверждение доступа OAuth-клиента
   */
  async oauthAuthorize(
    requestParameters: OauthAuthorizeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.oauthAuthorizeRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Отправка формы согласия со страницы /oauth/authorize: выпуск authorization code и редирект на redirect_uri клиента. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * Одобрить запрос авторизации
   */
  async oauthAuthorizeApproveRaw(
    requestParameters: OauthAuthorizeApproveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['authToken'] == null) {
      throw new runtime.RequiredError(
        'authToken',
        'Required parameter "authToken" was null or undefined when calling oauthAuthorizeApprove().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const consumes: runtime.Consume[] = [
      { contentType: 'application/x-www-form-urlencoded' },
    ]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['authToken'] != null) {
      formParams.append('auth_token', requestParameters['authToken'] as any)
    }

    if (requestParameters['token'] != null) {
      formParams.append('_token', requestParameters['token'] as any)
    }

    const response = await this.request(
      {
        path: `/oauth/authorize`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Отправка формы согласия со страницы /oauth/authorize: выпуск authorization code и редирект на redirect_uri клиента. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * Одобрить запрос авторизации
   */
  async oauthAuthorizeApprove(
    requestParameters: OauthAuthorizeApproveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.oauthAuthorizeApproveRaw(requestParameters, initOverrides)
  }

  /**
   * Отказ в согласии со страницы /oauth/authorize: редирект на redirect_uri клиента с error=access_denied и state. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * Отклонить запрос авторизации
   */
  async oauthAuthorizeDenyRaw(
    requestParameters: OauthAuthorizeDenyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['authToken'] == null) {
      throw new runtime.RequiredError(
        'authToken',
        'Required parameter "authToken" was null or undefined when calling oauthAuthorizeDeny().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const consumes: runtime.Consume[] = [
      { contentType: 'application/x-www-form-urlencoded' },
    ]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['authToken'] != null) {
      formParams.append('auth_token', requestParameters['authToken'] as any)
    }

    if (requestParameters['token'] != null) {
      formParams.append('_token', requestParameters['token'] as any)
    }

    const response = await this.request(
      {
        path: `/oauth/authorize`,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Отказ в согласии со страницы /oauth/authorize: редирект на redirect_uri клиента с error=access_denied и state. Браузерный эндпоинт (middleware web: сессия + CSRF).
   * Отклонить запрос авторизации
   */
  async oauthAuthorizeDeny(
    requestParameters: OauthAuthorizeDenyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.oauthAuthorizeDenyRaw(requestParameters, initOverrides)
  }

  /**
   * Выпуск access/refresh токенов напрямую через OAuth2-сервер Passport (grants: password, authorization_code). В отличие от /api/v1/login возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * Авторизация (OAuth2 token)
   */
  async oauthLoginRaw(
    requestParameters: OauthLoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OauthLogin200Response>> {
    if (requestParameters['oauthLoginRequest'] == null) {
      throw new runtime.RequiredError(
        'oauthLoginRequest',
        'Required parameter "oauthLoginRequest" was null or undefined when calling oauthLogin().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/oauth/token`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: OauthLoginRequestToJSON(requestParameters['oauthLoginRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OauthLogin200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Выпуск access/refresh токенов напрямую через OAuth2-сервер Passport (grants: password, authorization_code). В отличие от /api/v1/login возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * Авторизация (OAuth2 token)
   */
  async oauthLogin(
    requestParameters: OauthLoginOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OauthLogin200Response> {
    const response = await this.oauthLoginRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Отдельная страница входа для OAuth authorization code flow: при наличии client_id/state сохраняет все параметры запроса в сессию для возврата на /oauth/authorize после входа. Браузерный эндпоинт (middleware web, сессия).
   * Страница входа OAuth
   */
  async oauthLoginFormRaw(
    requestParameters: OauthLoginFormRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    const queryParameters: any = {}

    if (requestParameters['clientId'] != null) {
      queryParameters['client_id'] = requestParameters['clientId']
    }

    if (requestParameters['state'] != null) {
      queryParameters['state'] = requestParameters['state']
    }

    if (requestParameters['redirectUri'] != null) {
      queryParameters['redirect_uri'] = requestParameters['redirectUri']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/oauth/login`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response)
    } else {
      return new runtime.TextApiResponse(response) as any
    }
  }

  /**
   * Отдельная страница входа для OAuth authorization code flow: при наличии client_id/state сохраняет все параметры запроса в сессию для возврата на /oauth/authorize после входа. Браузерный эндпоинт (middleware web, сессия).
   * Страница входа OAuth
   */
  async oauthLoginForm(
    requestParameters: OauthLoginFormRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.oauthLoginFormRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Вход по email/паролю (guard web, сессия + CSRF) со страницы OAuth. При успехе — редирект на /oauth/authorize с сохранёнными в сессии параметрами (или на /, если их не было), при неудаче — назад на форму с ошибками в сессии.
   * Вход на странице OAuth
   */
  async oauthLoginSubmitRaw(
    requestParameters: OauthLoginSubmitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['email'] == null) {
      throw new runtime.RequiredError(
        'email',
        'Required parameter "email" was null or undefined when calling oauthLoginSubmit().'
      )
    }

    if (requestParameters['password'] == null) {
      throw new runtime.RequiredError(
        'password',
        'Required parameter "password" was null or undefined when calling oauthLoginSubmit().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const consumes: runtime.Consume[] = [
      { contentType: 'application/x-www-form-urlencoded' },
    ]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['email'] != null) {
      formParams.append('email', requestParameters['email'] as any)
    }

    if (requestParameters['password'] != null) {
      formParams.append('password', requestParameters['password'] as any)
    }

    if (requestParameters['token'] != null) {
      formParams.append('_token', requestParameters['token'] as any)
    }

    const response = await this.request(
      {
        path: `/oauth/login`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Вход по email/паролю (guard web, сессия + CSRF) со страницы OAuth. При успехе — редирект на /oauth/authorize с сохранёнными в сессии параметрами (или на /, если их не было), при неудаче — назад на форму с ошибками в сессии.
   * Вход на странице OAuth
   */
  async oauthLoginSubmit(
    requestParameters: OauthLoginSubmitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.oauthLoginSubmitRaw(requestParameters, initOverrides)
  }

  /**
   * Обновление пары токенов напрямую через OAuth2-сервер Passport (grant refresh_token). Возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * Обновление аутентификации (OAuth2 refresh)
   */
  async oauthTokenRefreshRaw(
    requestParameters: OauthTokenRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OauthLogin200Response>> {
    if (requestParameters['oauthTokenRefreshRequest'] == null) {
      throw new runtime.RequiredError(
        'oauthTokenRefreshRequest',
        'Required parameter "oauthTokenRefreshRequest" was null or undefined when calling oauthTokenRefresh().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/oauth/token/refresh`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: OauthTokenRefreshRequestToJSON(
          requestParameters['oauthTokenRefreshRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OauthLogin200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Обновление пары токенов напрямую через OAuth2-сервер Passport (grant refresh_token). Возвращает сырой ответ OAuth2 в snake_case без конверта success_response. Также принимает application/x-www-form-urlencoded.
   * Обновление аутентификации (OAuth2 refresh)
   */
  async oauthTokenRefresh(
    requestParameters: OauthTokenRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OauthLogin200Response> {
    const response = await this.oauthTokenRefreshRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Отмечает уведомление прочитанным. Отметить можно только собственное уведомление текущего пользователя.
   * Отметить уведомление прочитанным
   */
  async readUserNotificationRaw(
    requestParameters: ReadUserNotificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Logout200Response>> {
    if (requestParameters['notification'] == null) {
      throw new runtime.RequiredError(
        'notification',
        'Required parameter "notification" was null or undefined when calling readUserNotification().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/notifications/{notification}`.replace(
          `{${'notification'}}`,
          encodeURIComponent(String(requestParameters['notification']))
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Logout200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Отмечает уведомление прочитанным. Отметить можно только собственное уведомление текущего пользователя.
   * Отметить уведомление прочитанным
   */
  async readUserNotification(
    requestParameters: ReadUserNotificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Logout200Response> {
    const response = await this.readUserNotificationRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Регистрация нового пользователя. Throttle 5 запросов/мин с IP; UTM-метки и промокод (utmClientId, promocode) фиксируются middleware для трекинга. Пользователь создаётся с неподтверждённым email — письмо подтверждения отправляется на указанный адрес.
   * Зарегистрировать нового пользователя
   */
  async registrationRaw(
    requestParameters: RegistrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Registration200Response>> {
    if (requestParameters['registrationRequest'] == null) {
      throw new runtime.RequiredError(
        'registrationRequest',
        'Required parameter "registrationRequest" was null or undefined when calling registration().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/auth/register`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RegistrationRequestToJSON(
          requestParameters['registrationRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Registration200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Регистрация нового пользователя. Throttle 5 запросов/мин с IP; UTM-метки и промокод (utmClientId, promocode) фиксируются middleware для трекинга. Пользователь создаётся с неподтверждённым email — письмо подтверждения отправляется на указанный адрес.
   * Зарегистрировать нового пользователя
   */
  async registration(
    requestParameters: RegistrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Registration200Response> {
    const response = await this.registrationRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Повторная отправка письма подтверждения email по адресу (без авторизации). Троттлинг выполняется в контроллере: лимит 5 писем на адрес за окно 4 часа, минимальная пауза между письмами 60 секунд (счётчики в Redis) и per-IP лимит запросов в минуту. Ответ для несуществующего email имитирует нулевые счётчики (anti-enumeration), письмо не отправляется.
   * Повторная отправка письма подтверждения
   */
  async resendVerificationEmailRaw(
    requestParameters: ResendVerificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResendVerificationEmail200Response>> {
    if (requestParameters['resendVerificationEmailRequest'] == null) {
      throw new runtime.RequiredError(
        'resendVerificationEmailRequest',
        'Required parameter "resendVerificationEmailRequest" was null or undefined when calling resendVerificationEmail().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/auth/email/resend`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ResendVerificationEmailRequestToJSON(
          requestParameters['resendVerificationEmailRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResendVerificationEmail200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Повторная отправка письма подтверждения email по адресу (без авторизации). Троттлинг выполняется в контроллере: лимит 5 писем на адрес за окно 4 часа, минимальная пауза между письмами 60 секунд (счётчики в Redis) и per-IP лимит запросов в минуту. Ответ для несуществующего email имитирует нулевые счётчики (anti-enumeration), письмо не отправляется.
   * Повторная отправка письма подтверждения
   */
  async resendVerificationEmail(
    requestParameters: ResendVerificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResendVerificationEmail200Response> {
    const response = await this.resendVerificationEmailRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Подтверждение кода сброса, пришедшего на почту (запрашивается через /api/v1/user/forget-password). Код одноразовый: после проверки выпускается верификационный токен (действует 10 минут) для установки нового пароля через /api/v1/user/new-password. Публичный эндпоинт.
   * Проверка кода сброса пароля
   */
  async resetPasswordTokenRaw(
    requestParameters: ResetPasswordTokenOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResetPasswordToken200Response>> {
    if (requestParameters['resetPasswordTokenRequest'] == null) {
      throw new runtime.RequiredError(
        'resetPasswordTokenRequest',
        'Required parameter "resetPasswordTokenRequest" was null or undefined when calling resetPasswordToken().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/user/reset-password-token`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ResetPasswordTokenRequestToJSON(
          requestParameters['resetPasswordTokenRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResetPasswordToken200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Подтверждение кода сброса, пришедшего на почту (запрашивается через /api/v1/user/forget-password). Код одноразовый: после проверки выпускается верификационный токен (действует 10 минут) для установки нового пароля через /api/v1/user/new-password. Публичный эндпоинт.
   * Проверка кода сброса пароля
   */
  async resetPasswordToken(
    requestParameters: ResetPasswordTokenOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResetPasswordToken200Response> {
    const response = await this.resetPasswordTokenRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Заявка в партнёрскую программу: сохраняет email для партнёрской программы текущего пользователя. Идемпотентно — повторный запрос с уже сохранённым email не создаёт дубликат. Требуется подтверждённый email.
   * Заявка в партнёрскую программу
   */
  async saveAffiliateProgramRaw(
    requestParameters: SaveAffiliateProgramOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SaveAffiliateProgram200Response>> {
    if (requestParameters['saveAffiliateProgramRequest'] == null) {
      throw new runtime.RequiredError(
        'saveAffiliateProgramRequest',
        'Required parameter "saveAffiliateProgramRequest" was null or undefined when calling saveAffiliateProgram().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/affiliate-program`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SaveAffiliateProgramRequestToJSON(
          requestParameters['saveAffiliateProgramRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SaveAffiliateProgram200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Заявка в партнёрскую программу: сохраняет email для партнёрской программы текущего пользователя. Идемпотентно — повторный запрос с уже сохранённым email не создаёт дубликат. Требуется подтверждённый email.
   * Заявка в партнёрскую программу
   */
  async saveAffiliateProgram(
    requestParameters: SaveAffiliateProgramOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SaveAffiliateProgram200Response> {
    const response = await this.saveAffiliateProgramRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Полная замена списка почт для уведомлений: переданный массив синхронизируется со списком пользователя (отсутствующие в запросе записи удаляются). Максимум 7 адресов, все должны быть уникальны. Требуется подтверждённый email.
   * Сохранить список почт для уведомлений
   */
  async saveNotificationEmailRaw(
    requestParameters: SaveNotificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNotificationEmails200Response>> {
    if (requestParameters['saveNotificationEmailRequest'] == null) {
      throw new runtime.RequiredError(
        'saveNotificationEmailRequest',
        'Required parameter "saveNotificationEmailRequest" was null or undefined when calling saveNotificationEmail().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user/notification-emails`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SaveNotificationEmailRequestToJSON(
          requestParameters['saveNotificationEmailRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetNotificationEmails200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Полная замена списка почт для уведомлений: переданный массив синхронизируется со списком пользователя (отсутствующие в запросе записи удаляются). Максимум 7 адресов, все должны быть уникальны. Требуется подтверждённый email.
   * Сохранить список почт для уведомлений
   */
  async saveNotificationEmail(
    requestParameters: SaveNotificationEmailOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNotificationEmails200Response> {
    const response = await this.saveNotificationEmailRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Обновление пары токенов по refresh_token (OAuth2 refresh grant) через адаптер над Passport.
   * Обновление аутентификации
   */
  async tokenRefreshRaw(
    requestParameters: TokenRefreshRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Login200Response>> {
    if (requestParameters['oauthTokenRefreshRequest'] == null) {
      throw new runtime.RequiredError(
        'oauthTokenRefreshRequest',
        'Required parameter "oauthTokenRefreshRequest" was null or undefined when calling tokenRefresh().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/login/refresh`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: OauthTokenRefreshRequestToJSON(
          requestParameters['oauthTokenRefreshRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Login200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Обновление пары токенов по refresh_token (OAuth2 refresh grant) через адаптер над Passport.
   * Обновление аутентификации
   */
  async tokenRefresh(
    requestParameters: TokenRefreshRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Login200Response> {
    const response = await this.tokenRefreshRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Обновление личных данных текущего пользователя: ФИО и телефон (таблица users), тип и данные организации (таблица users_meta). Телефон уникален среди пользователей. Требуется подтверждённый email.
   * Обновить данные пользователя
   */
  async updateUserProfileRaw(
    requestParameters: UpdateUserProfileOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetUserProfile200Response>> {
    if (requestParameters['updateUserProfileRequest'] == null) {
      throw new runtime.RequiredError(
        'updateUserProfileRequest',
        'Required parameter "updateUserProfileRequest" was null or undefined when calling updateUserProfile().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/user`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UpdateUserProfileRequestToJSON(
          requestParameters['updateUserProfileRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetUserProfile200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Обновление личных данных текущего пользователя: ФИО и телефон (таблица users), тип и данные организации (таблица users_meta). Телефон уникален среди пользователей. Требуется подтверждённый email.
   * Обновить данные пользователя
   */
  async updateUserProfile(
    requestParameters: UpdateUserProfileOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetUserProfile200Response> {
    const response = await this.updateUserProfileRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Подтверждение email по подписанной ссылке (relative signed URL) из письма. При успехе сразу выпускается пара токенов для входа в личный кабинет. Throttle 10 запросов/мин с IP.
   * Подтверждение email
   */
  async verifyEmailRaw(
    requestParameters: VerifyEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<VerifyEmail200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling verifyEmail().'
      )
    }

    if (requestParameters['hash'] == null) {
      throw new runtime.RequiredError(
        'hash',
        'Required parameter "hash" was null or undefined when calling verifyEmail().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/auth/email/verify/{id}/{hash}`
          .replace(
            `{${'id'}}`,
            encodeURIComponent(String(requestParameters['id']))
          )
          .replace(
            `{${'hash'}}`,
            encodeURIComponent(String(requestParameters['hash']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      VerifyEmail200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Подтверждение email по подписанной ссылке (relative signed URL) из письма. При успехе сразу выпускается пара токенов для входа в личный кабинет. Throttle 10 запросов/мин с IP.
   * Подтверждение email
   */
  async verifyEmail(
    requestParameters: VerifyEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<VerifyEmail200Response> {
    const response = await this.verifyEmailRaw(requestParameters, initOverrides)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetUserNotificationsNotificationTypeEnum {
  All = 'all',
  Unread = 'unread',
  Read = 'read',
}
/**
 * @export
 * @enum {string}
 */
export enum OauthAuthorizeResponseTypeEnum {
  Code = 'code',
}
/**
 * @export
 * @enum {string}
 */
export enum OauthAuthorizePromptEnum {
  None = 'none',
  Login = 'login',
  Consent = 'consent',
}
